import { EMERGENCY_CALLS } from '@rsos/constants/incidentTypes';
import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const JURISDICTION_VIEW_EVENT_NAMES = {
  CLICK_ALERT_MARKER: 'click_alert_marker',
  CLICK_CALL_MARKER: 'click_911_call_marker',
  CLOSE_ALERT_PANE: 'click_close_alert_event_pane',
  CLICK_TAB: 'click_tab',
  CLICK_CALL_FROM_MAP: 'click_on_call_from_map',
  CLOSE_RADE_CARD: 'click_close_additional_data_card',
};

export const trackAlertMarkerClicks = (activeQueueTab, irpVersion, alertID) => {
  let displayTab = activeQueueTab;
  if (activeQueueTab === EMERGENCY_CALLS) {
    displayTab = '911 call';
  }
  gspx.trackEvent({
    name: JURISDICTION_VIEW_EVENT_NAMES.CLICK_ALERT_MARKER,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Alert',
      legacy_name: `Click Alert marker when ${displayTab} tab is active`,
      Category: 'Alert',
      'Launched date': new Date(),
      irpVersion,
    },
    entities: {
      alert_id: alertID,
    },
  });
};

export const trackCallMarkerClicks = (activeQueueTab, irpVersion) => {
  let displayTab = activeQueueTab;
  if (activeQueueTab === EMERGENCY_CALLS) {
    displayTab = '911 call';
  }
  gspx.trackEvent({
    name: JURISDICTION_VIEW_EVENT_NAMES.CLICK_CALL_MARKER,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Alert',
      legacy_name: `Click 911 call marker when ${displayTab} tab is active`,
      Category: 'Alert',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackCloseAlertPane = (selectedAlertID, irpVersion) => {
  gspx.trackEvent({
    name: JURISDICTION_VIEW_EVENT_NAMES.CLOSE_ALERT_PANE,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Alert',
      legacy_name: 'Click x to close the alert event pane',
      Category: 'Alert',
      'Launched date': new Date(),
      irpVersion,
    },
    entities: {
      alert_id: selectedAlertID,
    },
  });
};

export const trackClickTab = (tabName, irpVersion) => {
  gspx.trackEvent({
    name: JURISDICTION_VIEW_EVENT_NAMES.CLICK_TAB,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Alert',
      legacy_name: `Click ${tabName} tab`,
      Category: 'Alert',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackClickOnCallFromMap = irpVersion => {
  gspx.trackEvent({
    name: JURISDICTION_VIEW_EVENT_NAMES.CLICK_CALL_FROM_MAP,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Data Jurisdiction',
      legacy_name: 'Click on Call From Map',
      Category: 'Jurisdiction View',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackCloseRADECard = (irpVersion, portalType) => {
  gspx.trackEvent({
    name: JURISDICTION_VIEW_EVENT_NAMES.CLOSE_RADE_CARD,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Data Jurisdiction',
      legacy_name: 'Click x to close additional data card',
      Category: 'Jurisdiction View',
      'Launched date': new Date(),
      irpVersion,
      portalType,
    },
  });
};
